import { multiImageInnerCarouselStyles } from '@bingads-webui-campaign-react/shared-image-preview-styles';
import { floatButtonStyle } from '@bingads-webui-campaign-react/common-styles';
import { customizedUIBlockerStyle } from './customize-ui-blocker-style';

export const getImageExtensionsPaneStyle = (_, { palette, iconFontFamily = 'MsAds MDL2 Assets' }) => {
  const border = '1px solid #B3B0AD';

  return {
    panelFooter: {
      background: 'white',
      bottom: 0,
      position: 'fixed',
      border: 'none',
      '& button ~ button': {
        marginLeft: 8,
      },
    },
    cropPanel: {
      '& .image-crop-editor-container': {
        height: 'calc(100% - 60px)',
        overflowY: 'auto',
      },
      '& .extension-images-control': {
        '& .image-experience-content': {
          marginBottom: '10px',
        },
        '& .error': {
          color: '#a4262c',
        },
        '& .image-section-label': {
          display: 'inline-block',
          '& label': {
            float: 'left',
          },
          '& .helpbutton': {
            float: 'left',
          },
        },
        '& .add-image-button': {
          display: 'block',
          background: `${palette.white} !important`,
          border: `1px solid ${palette.neutralSecondaryAlt}`,
          borderRadius: 2,
          boxSizing: 'border-box',
          fontWeight: 600,
          margin: '0 !important',

          '&:before': {
            color: palette.themePrimary,
            content: '"\\E710"',
            fontFamily: iconFontFamily,
            fontWeight: 'normal',
            marginRight: 8,
          },
        },
        '& .new-preview-carousel-container': {
          // inner carousel in a carousel
          border: '1px solid #C8C8C8',
          margin: 0,
          width: '100%',
          minWidth: 669,
          ...multiImageInnerCarouselStyles(palette, iconFontFamily),

          '& .new-responsive-ad-preview-container': {
            height: 500,
            overflow: 'hidden',

            '& .responsive-ad-preview-content': {
              border: '1px solid #C8C8C8',
            },
          },

          '& .preview-type-string': {
            bottom: 25,
            fontSize: 14,
            lineHeight: '20px',
            paddingTop: 12,
            position: 'fixed',
            textAlign: 'center',
            width: '100%',
          },
          '& .additional-disclaimer': {
            fontSize: 12,
            lineHeight: '20px',
            textAlign: 'left',
            bottom: 0,
            padding: '0 24px',
            position: 'fixed',
          },
          '& .disclaimer-info': {
            fontSize: 12,
            lineHeight: '20px',
            textAlign: 'left',
            padding: '0 24px 20px 24px',
          },
        },
        '& .image-experience-content .image-list-view-content': {
          position: 'relative',
          '& .image-list': {
            '& .image-list-label': {
              fontSize: 14,
              fontWeight: 600,
              lineHeight: '19px',
            },

            '& .image-list-content': {
              display: 'flex',
              border: '1px solid #C8C8C8',
              margin: '8px 0 0 0',
              padding: '16px 16px 12px 16px',
              width: 'fit-content',

              '& .image-list-item': {
                float: 'none',
                padding: 0,

                '& ~ .image-list-item': {
                  marginLeft: 8,
                },

                '& .dropdown.btn-group': {
                  display: 'block',

                  '&.image-edit-dropdown .dropdown-toggle': {
                    extend: floatButtonStyle({ palette }).floatButton,
                    fontFamily: iconFontFamily,
                    fontSize: 16,
                    lineHeight: 1,
                    float: 'right',
                    margin: 0,

                    '&:before': {
                      content: '"\\E70F"',
                    },
                  },

                  '& .caret': {
                    display: 'none',
                  },
                },

                '& .image-item-ratio-label': {
                  fontSize: 14,
                  lineHeight: '20px',
                },
              },

              '& .remove-all-button': {
                background: 'none',
                border: 'none',
                color: palette.neutralSecondary,
                fontFamily: iconFontFamily,
                fontSize: 12,
                lineHeight: 1,
                margin: '-14px -14px 0 0',
                padding: 8,
                width: 28,
                height: 28,

                '&:before': {
                  content: '"\\E711"',
                },
              },
            },
          },
        },
      },
      '& .image-experience-content .image-list-view-content .image-list': {
        margin: '10px 0',
        '& .image-list-label': {
          fontSize: 12,
          fontWeight: '700',
        },
        '& .image-list-item': {
          border: 'none',
          position: 'relative',
          float: 'left',
          padding: 5,
          fontSize: 12,
          '& .image-item-ratio-label': {
            marginTop: 5,
            height: '20px !important',
            textAlign: 'center',
          },
          '& .empty-image-list-item': {
            '& button': {
              border: 'dashed',
              background: 'white',
              borderColor: '#CCCCCC',
              borderWidth: 'thin',
              color: '#00a2ff',
              textAlign: 'center',
            },
            '& button:focus': {
              outline: 'none !important',
            },
          },
          '& .image-list-item-image': {
            position: 'relative',
            '& .dropdown.btn-group': {
              display: 'none',
              position: 'absolute',
              width: '100%',
              bottom: '0',
              '& .image-edit-dropdown .dropdown-toggle': {
                color: 'white',
                background: 'rgba(0,0,0,0.3)',
                width: '100%',
                border: '0',
                padding: 2,
              },
              '& .dropdown-menu': {
                margin: '0',
                borderRadius: '0',
                border: '2px solid rgba(0,0,0,0.15)',
              },
              '& .dropdown-menu li': {
                float: 'unset',
              },
              '& .dropdown-menu li a': {
                paddingLeft: 10,
              },
            },
          },
        },
      },
    },
    container: {
      margin: '16px 0',
      paddingBottom: 10,
      borderTop: border,
      borderBottom: border,

      ...customizedUIBlockerStyle,

      '& .teaching-bubble-content': {
        minWidth: 364,
      },

      '& .image-suggestion-carousel-root .panel': {
        marginTop: 0,
      },
    },
    addIcon: {
      marginRight: 8,
      top: 0,
      color: palette.themeSecondary,
      fontSize: 16,
    },
    listContainer: {
      margin: '16px 0 0 0',
    },
    alertBanner: {
      marginTop: 5,
    },
    labelContainer: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '31px',
    },
  };
};

export const overrideImageRecommendationClasses = {
  panelHeading: {
    display: 'flex',
  },
  panelTitle: {
    flexGrow: 0,
  },
  seeAll: {
    overflow: 'visible',
    maxWidth: '50px',
  },
};
